import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/header_logo_small.png'


const _hoisted_1 = {
  id: "footer",
  class: "au-footer"
}
const _hoisted_2 = { class: "au-footer__bar py-3" }
const _hoisted_3 = { class: "container d-flex flex-wrap justify-content-between align-items-center gap-2" }
const _hoisted_4 = { class: "d-flex align-items-center gap-4" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

import {useContentsStore} from "@/store/contents-store";
import {storeToRefs} from "pinia";
import { logout } from "@/services/auth-service";


export default /*@__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const store = useContentsStore();
const { logged } = storeToRefs(store);
const year = new Date().getFullYear();

async function logoutUser() {
  await logout();
  logged.value = false;
}

function toTop() {
  window.scrollTo({ top: 0, behavior: "smooth" });
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"container pt-5 pb-4\"><div class=\"row g-4 g-lg-5\"><div class=\"col-lg-3\"><div class=\"au-brand mb-3\"><span class=\"au-brand__mark\" aria-hidden=\"true\"><img src=\"" + _imports_0 + "\"></span><span class=\"au-brand__text\"><span class=\"au-brand__name\">ZPS Auxilium</span><span class=\"au-brand__tag\">služby seniorom</span></span></div><p class=\"small mb-0\">Láskavá a plnohodnotná starostlivosť o seniorov vo Varíne.</p></div><div class=\"col-sm-6 col-lg-3\"><h4>Adresa</h4><address class=\"mb-0\"><ul><li>Zariadenie pre seniorov<br><strong class=\"text-white\">Auxilium, n.o.</strong></li><li>Jozefa Martinčeka 108/50</li><li>013 03 Varín</li></ul></address></div><div class=\"col-sm-6 col-lg-3\"><h4>Telefón a email</h4><ul><li><i class=\"bi bi-telephone me-2\"></i><a href=\"tel:+421415006028\">041 / 500 60 28</a></li><li><i class=\"bi bi-telephone me-2\"></i><a href=\"tel:+421415006029\">041 / 500 60 29</a></li><li><i class=\"bi bi-envelope me-2\"></i><a href=\"mailto:zpsauxilium@gmail.com\">zpsauxilium@gmail.com</a></li><li><i class=\"bi bi-envelope me-2\"></i><a href=\"mailto:penzionvarin@gmail.com\">penzionvarin@gmail.com</a></li></ul></div><div class=\"col-sm-6 col-lg-3\"><h4>Fakturačné údaje</h4><ul><li>IČO: 57 603 189</li><li>Banka: Slovenská sporiteľňa, a.s.</li><li>IBAN: SK21 0900 0000 0052 4999 8040</li></ul></div></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "© " + _toDisplayString(_unref(year)) + " Zariadenie pre seniorov Auxilium, n.o.", 1),
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "#domov",
              onClick: _withModifiers(toTop, ["prevent"])
            }, "Späť hore ↑")
          ]),
          (!_unref(logged))
            ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                _createVNode(_component_router_link, { to: {name: 'login'} }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode("Prihlásiť", -1)
                  ]))]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("li", _hoisted_6, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: _withModifiers(logoutUser, ["prevent"])
                }, "Odhlásiť")
              ])),
          _cache[1] || (_cache[1] = _createElementVNode("li", {
            class: "d-none",
            id: "contact-id"
          }, "7ebc169393f3d25db318db511c59ae03816a0a87", -1))
        ])
      ])
    ])
  ]))
}
}

})